import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '../src/styles/style.scss';
import '../node_modules/bootstrap/js/src/dropdown';
import '../node_modules/bootstrap/js/src/modal';
import '../node_modules/bootstrap/js/src/collapse';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

  // <React.StrictMode>
  // </React.StrictMode>
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
